import Panel from '../../../../components/UI/Panel';
import { Grid } from '@mui/material';
import CheckboxInput from '../UI/CheckboxInput';

export default function DepartmentServePreferencesPatientInfo({
  form,
}: {
  form: any;
}) {
  return (
    <Panel headerText="Patient">
      <Grid container>
        <Grid item xs={6}>
          <CheckboxInput
            label="Patient Address"
            keyName={`${form}.values.custodianDetails.servePreferences.isPatientAddress`}
            checked={
              form?.values?.custodianDetails?.servePreferences?.isPatientAddress
            }
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isPatientAddress`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isPatientAddress`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6} pl={3}>
          <CheckboxInput
            label="Patient Account Number"
            keyName={`${form}.values.custodianDetails.servePreferences.isPatientAccountNumber`}
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isPatientAccountNumber
            }
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isPatientAccountNumber`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isPatientAccountNumber`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <CheckboxInput
            label="Patient Full SSN Number"
            keyName={`${form}.values.custodianDetails.servePreferences.isPatientFullSSNNumber`}
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isPatientFullSSNNumber
            }
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isPatientFullSSNNumber`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isPatientFullSSNNumber`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6} pl={3}>
          <CheckboxInput
            label="Patient Initial Sensitive Information"
            keyName={`${form}.values.custodianDetails.servePreferences.isPatientInitialSensitiveInformation`}
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isPatientInitialSensitiveInformation
            }
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isPatientInitialSensitiveInformation`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isPatientInitialSensitiveInformation`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <CheckboxInput
            label="Electronic Signature Accepted"
            keyName={`${form}.values.custodianDetails.servePreferences.isElectronicSignatureAccepted`}
            checked={
              form?.values?.custodianDetails?.servePreferences
                ?.isElectronicSignatureAccepted
            }
            onChange={(e: any) => {
              form.setFieldValue(
                `custodianDetails.servePreferences.isElectronicSignatureAccepted`,
                e.target.checked,
              );
            }}
            onBlur={() => {
              form.setFieldTouched(
                `custodianDetails.servePreferences.isElectronicSignatureAccepted`,
                true,
              );
            }}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Panel>
  );
}
